var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-content',[(_vm.errorMessage)?_c('errorMessages'):_vm._e(),_c('div',{staticClass:"AppPadding"},[_c('router-view')],1),(_vm.isAuthenticated)?_c('autoLogoutPopup'):_vm._e()],1),_c('toastMessage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }